import EmergencyEquipment from './EmergencyEquipment';
export default EmergencyEquipment;
